import { ActivityUnit } from '../enums/ActivityDataTypeEnum';
import { EmissionSourceFactorUnitType, EmissionSourceGreenHouseGases } from '../enums/EmissionSourceEnum';

class EmissionSourceConstants {
  public static readonly EMISSION_FACTOR_TYPE_TO_ACTIVITY_UNIT_DROPDOWN_OPTIONS: Record<
    EmissionSourceFactorUnitType,
    ActivityUnit[]
  > = {
    LINEAR: [
      ActivityUnit.MM,
      ActivityUnit.CM,
      ActivityUnit.M,
      ActivityUnit.KM,
      ActivityUnit.INCH,
      ActivityUnit.FEET,
      ActivityUnit.YARD,
      ActivityUnit.MILE,
      ActivityUnit.NMI,
    ],
    SQUARE: [ActivityUnit.M2, ActivityUnit.KM2, ActivityUnit.HECTARE, ActivityUnit.ACRE],
    CUBIC: [
      ActivityUnit.ML,
      ActivityUnit.L,
      ActivityUnit.MILLION_L,
      ActivityUnit.PINT,
      ActivityUnit.GALLON,
      ActivityUnit.BUSHEL,
      ActivityUnit.KL,
      ActivityUnit.M3,
      ActivityUnit.THOUSAND_M3,
      ActivityUnit.KM3,
      ActivityUnit.CM3,
      ActivityUnit.MM3,
    ],
    WEIGHT: [
      ActivityUnit.MG,
      ActivityUnit.G,
      ActivityUnit.KG,
      ActivityUnit.T,
      ActivityUnit.KT,
      ActivityUnit.OUNCE,
      ActivityUnit.POUND,
      ActivityUnit.LONG_TON,
      ActivityUnit.SHORT_TON,
      ActivityUnit.TDM,
    ],
    ENERGY_KWH: [ActivityUnit.KWH, ActivityUnit.KWH_GROSS_CV, ActivityUnit.MWH],
    ENERGY_J: [ActivityUnit.MJ, ActivityUnit.GJ, ActivityUnit.TJ],
    POWER: [ActivityUnit.WATT],
    CURRENCY: [ActivityUnit.MEU, ActivityUnit.THOUSAND_EU, ActivityUnit.EUR, ActivityUnit.USD],
    OTHER: [
      ActivityUnit.PERSON_DAY,
      ActivityUnit.PERSON_HOUR,
      ActivityUnit.ROLL,
      ActivityUnit.PACKET,
      ActivityUnit.PIECE,
      ActivityUnit.PAIR,
      ActivityUnit.EACH,
      ActivityUnit.SHEET_1,
      ActivityUnit.STRIP,
      ActivityUnit.UNIT,
      ActivityUnit.CAN,
      ActivityUnit.BOX_1,
      ActivityUnit.BOTTLE,
      ActivityUnit.BUCKET,
      ActivityUnit.BOWL,
      ActivityUnit.PKM,
      ActivityUnit.TKM,
      ActivityUnit.PERSON_TIME,
      ActivityUnit.TEU,
      ActivityUnit.TEU_KM,
      ActivityUnit.BAG,
      ActivityUnit.M2_HOUR,
      ActivityUnit.PERSON,
      ActivityUnit.SQUARE_FOOT_DAY,
      ActivityUnit.ROOM_DAY,
      ActivityUnit.GUEST_NIGHT,
      ActivityUnit.ITEM,
      ActivityUnit.SERVICE,
      ActivityUnit.PERSON_MEAL,
      ActivityUnit.SET,
      ActivityUnit.CUP,
      ActivityUnit.KG_DAY,
      ActivityUnit.KG_BOD,
      ActivityUnit.KM_YEAR,
      ActivityUnit.M_YEAR,
      ActivityUnit.M2_YEAR,
      ActivityUnit.HEAD_YEAR,
      ActivityUnit.FLOOR,
      ActivityUnit.VEHICLE,
      ActivityUnit.COPY,
      ActivityUnit.YEAR_KM2,
      ActivityUnit.WELL_UNIT,
      ActivityUnit.HEAD,
      ActivityUnit.WING,
      ActivityUnit.SCF,
      ActivityUnit.TON_PER_YEAR,
      ActivityUnit.MMBTU,
      ActivityUnit.PM,
      ActivityUnit.HP_HR,
      ActivityUnit.TON_PER_DAY,
      ActivityUnit.HOURS,
      ActivityUnit.HOUR,
      ActivityUnit.MINS,
      ActivityUnit.SEC,
      ActivityUnit.LUMPSUM,
      ActivityUnit.FUNCTIONAL_UNIT,
      ActivityUnit.WATTPEAK,
      ActivityUnit.M3_HOUR,
      ActivityUnit.TONNE_OF_OIL_EQU,
      ActivityUnit.DEVICE,
      ActivityUnit.MEAL,
      ActivityUnit.M3_KM,
      ActivityUnit.PASSENGER_EQU_KM,
      ActivityUnit.PERSON_MONTH,
      ActivityUnit.SHORT_TON_MILE,
      ActivityUnit.VEHICLE_MILE,
      ActivityUnit.PC,
      ActivityUnit.SPC,
      ActivityUnit.KPC,
      ActivityUnit.SML,
      ActivityUnit.EA,
      ActivityUnit['10K_WB'],
    ],
  };
  public static readonly FT_7_CUSTOMIZED_FACTOR_UNIT: Partial<
    Record<EmissionSourceGreenHouseGases, { activityUnit: ActivityUnit; ghgUnit: ActivityUnit }>
  > = {
    [EmissionSourceGreenHouseGases.CH4]: {
      activityUnit: ActivityUnit.PERSON_HOUR,
      ghgUnit: ActivityUnit.KG,
    },
  };
  public static readonly FT_14_1_CUSTOMIZED_FACTOR_UNIT: Partial<
    Record<EmissionSourceGreenHouseGases, { activityUnit: ActivityUnit; ghgUnit: ActivityUnit }>
  > = {
    [EmissionSourceGreenHouseGases.CH4]: {
      activityUnit: ActivityUnit.M3,
      ghgUnit: ActivityUnit.KG,
    },
    [EmissionSourceGreenHouseGases.N2O]: {
      activityUnit: ActivityUnit.KG,
      ghgUnit: ActivityUnit.KG,
    },
  };
  public static readonly FT_14_2_CUSTOMIZED_FACTOR_UNIT: Partial<
    Record<EmissionSourceGreenHouseGases, { activityUnit: ActivityUnit; ghgUnit: ActivityUnit }>
  > = {
    [EmissionSourceGreenHouseGases.CH4]: {
      activityUnit: ActivityUnit.KG,
      ghgUnit: ActivityUnit.KG,
    },
    [EmissionSourceGreenHouseGases.N2O]: {
      activityUnit: ActivityUnit.KG,
      ghgUnit: ActivityUnit.KG,
    },
  };
}

export default EmissionSourceConstants;
